<template lang="pug">
  .profile-page__content
    section.profile-page-form__section.profile-section
      .profile-section__title
        h2.profile-section-title Контактная информация

      .profile-section__body
        .form
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title ФИО
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Спортивная"
                )
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Должность
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Спортивная"
                )
          .form__elem
            .form-elem.form-elem_horizontal
              .form-elem__title Пункты
              .form-elem__body
                input.input.input_full(
                maxlength="50"
                value="Медицинские справки"
                )
          .form__elem.form__elem--align-right
            button.button.button_paint-main--light
              //.button__icon
                img(src="@/assets/images/icons/clip.svg")
              .button__text Добавить пункт
    section.form__elem.form__elem--align-right.form__elem_full
      button.button.button_paint-main.button_long
        .button__text Сохранить
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "OperatorCampContacts",
  data() {
    return {
      operatorPageData: {
        title: "О лагере",
        description: ""
        // "Здесь вы можете изменить данные своего профиля, следить за статусом заявки, а так же загрузить все необходимы для подачи заявки документы и информацию о детях"
      }
    };
  }
};
</script>
